import { CategoryListProps } from "../interfaces/CategoryInterface";
import CategoryItem from "./CategoryItem";
import SectionHeader from "../../components/SectionHeader";
import styles from "../styles/Category.module.scss";

export default function CategoryList(props: CategoryListProps) {
  return (
    <div className={styles.item_list_main}>
      <SectionHeader>CATEGORIES</SectionHeader>
      <div className={styles.item_list}>
        {props.categories.map((value, index) => {
          return <CategoryItem key={index} {...value}></CategoryItem>;
        })}
      </div>
    </div>
  );
}
